import React from "react";

const Chevron = ({open}) => (
    <svg width="16" height="16" viewBox="0 0 24 24"
         className={`inline-block transition-transform ${open ? 'rotate-90' : ''}`}>
        <path d="M9 6l6 6-6 6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    </svg>
);
const PlusIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" className="inline-block">
        <path d="M12 5v14M5 12h14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    </svg>
);

const ModalFormHeaderRow = ({title, open, onToggle, onAdd, addAria}) => (
    <div className="col-span-2 flex items-center mt-2">
        {
            onToggle ? (
                <button type="button" onClick={onToggle} className="flex items-center gap-2 text-sm font-semibold">
                    <Chevron open={open}/> <span>{title}</span>
                </button>
            ) : (
                <div className="flex items-center gap-2 text-sm font-semibold">
                    <span>{title}</span>
                </div>
            )
        }

        {onAdd && ((onToggle && open) || !onToggle) && (
            <button type="button" onClick={onAdd} title={addAria} aria-label={addAria}
                    className="p-1 rounded hover:bg-gray-100">
                <PlusIcon/>
            </button>
        )}
    </div>
);


export default ModalFormHeaderRow;